import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class Bank {
  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}bank`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.bank;
  };
}
export default new Bank();
